var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon-Color",
    className: "cls-1",
    d: "M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Zm0,2.18A9.82,9.82,0,1,0,21.82,12,9.82,9.82,0,0,0,12,2.18Zm0,14.18a1.1,1.1,0,1,1-1.09,1.09A1.09,1.09,0,0,1,12,16.36Zm.65-10.85a4.37,4.37,0,0,1,3.63,4.31,4.07,4.07,0,0,1-2.13,3.36,8.51,8.51,0,0,1-1.89,1,1.09,1.09,0,0,1-.81-2l.32-.12.21-.09a6.83,6.83,0,0,0,1-.52c.75-.51,1.15-1,1.15-1.55a2.18,2.18,0,0,0-4.17-.89l-.07.16a1.09,1.09,0,1,1-2-.72A4.36,4.36,0,0,1,12.65,5.51Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertQuestion);
export default __webpack_public_path__ + "static/media/alert-question.36888ef0a89d1513984bb6dd28808996.svg";
export { ForwardRef as ReactComponent };